import { Frequency } from "rrule";

/** Schedule recurrence. */
export enum ScheduleRecurrence {
    NoRepeat = "noRepeat",
    Hourly = "hourly",
    Daily = "daily",
    Weekly = "weekly",
    Monthly = "monthly",
}

export const SCHEDULE_RECURRENCE_LIST: readonly ScheduleRecurrence[] = [
    ScheduleRecurrence.NoRepeat,
    ScheduleRecurrence.Hourly,
    ScheduleRecurrence.Daily,
    ScheduleRecurrence.Weekly,
    ScheduleRecurrence.Monthly,
];

export const SCHEDULE_RECURRENCE_TO_READABLE: Readonly<Record<ScheduleRecurrence, string>> = {
    [ScheduleRecurrence.NoRepeat]: "Не повторять",
    [ScheduleRecurrence.Hourly]: "Ежечасно",
    [ScheduleRecurrence.Daily]: "Ежедневно",
    [ScheduleRecurrence.Weekly]: "Еженедельно",
    [ScheduleRecurrence.Monthly]: "Ежемесячно",
};

/**
 * Maps RRule frequency to schedule recurrence.
 * @param value RRule frequency.
 */
export function mapFromRRuleFrequency(value: Frequency): ScheduleRecurrence {
    switch (value) {
        case Frequency.HOURLY:
            return ScheduleRecurrence.Hourly;
        case Frequency.DAILY:
            return ScheduleRecurrence.Daily;
        case Frequency.WEEKLY:
            return ScheduleRecurrence.Weekly;
        case Frequency.MONTHLY:
            return ScheduleRecurrence.Monthly;
        case Frequency.MINUTELY:
        case Frequency.SECONDLY:
        case Frequency.YEARLY:
        default:
            return ScheduleRecurrence.NoRepeat;
    }
}
